import { useNavigate } from "react-router-dom";
import { routes } from "@/app/navigation/routes";
import styles from "./SettingsContactUsPage.module.css";
import andyHdLogo from "@/assets/andyhdlogo.png";

export const SettingsContactUsPage = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>Contact us</h1>

      <div className={styles.hero}>
        <img src={andyHdLogo} alt="Andy logo" className={styles.heroLogo} />
      </div>

      <section className={styles.content}>
        <h2 className={styles.heading}>
          <span>Contact your property tax</span>
          <span className={styles.headingAccent}> Consultant Now</span>
        </h2>
        <p className={styles.subtext}>Chat with our expert team members to help your in tax</p>

        <button
          type="button"
          className={styles.chatButton}
          onClick={() => navigate(routes.settingsContactUsChat)}
        >
          <span aria-hidden="true">💬</span>
          <span>Start Chart</span>
        </button>
      </section>
    </div>
  );
};
